<!--
 * @Author: huanhaun
 * 课程item
-->
<template>
<div class="item">
    <!-- 课程报名 -->
    <template v-if="type === 1">
        <img :src="item.cover" />
        <div class="body1">
            <div class="title">
                <p>{{item.subject_stage.name}}</p>
                <span>座位费￥<span>{{item.seat_fee}}</span></span>
            </div>
            <div class="line">
                <p>{{item.class}}</p>
                <div v-for="(_item, _index) in item.subject_name_list" :key="_index">{{_item}}</div>
            </div>
            <p class="time">{{item.start_time}}</p>
            <div class="address">
                <p>{{item.area}}{{item.address}}</p>
                <span>{{item.enroll_num_sum}}人已报名</span>
            </div>
            <div class="btn" @click="onPressItem('courseDetail', {id: item.subject_stage.id})">去报名</div>
        </div>
        <div class="type">
            <p>{{item.status_text}}</p>
        </div>
    </template>
    <!-- 课程介绍 -->
    <template v-else-if="type === 2">
        <img :src="item.home_img" />
        <div class="student-num td-fcc">{{item.student_num || 0}}人在学</div>
        <div class="body2">
            <div>
                <p>{{item.name}}</p>
                <span>{{item.student_num || 0}}人在学</span>
            </div>
            <p class="text-j">{{item.desc}}</p>
            <div class="btn" @click="onPressItem('courseIntroduction', {id: item.id})">查看详情</div>
        </div>
    </template>
    <!-- 我的课程 -->
    <template v-else-if="type === 3">
        <img :src="item.subject_img" alt="">
        <div class="body1">
            <div class="title">
                <p>{{item.name}}</p>
                <span>座位费￥<span>{{item.seat_fee}}</span></span>
            </div>
            <div class="line">
                <p>{{item.class}}</p>
                <div v-for="(_item, _index) in item.subject_name_list" :key="_index">{{_item}}</div>
            </div>
            <p class="time">{{item.start_time}}</p>
            <div class="address">
                <p>{{item.address}}</p>
                <span>{{item.enroll_num_sum}}人已报名</span>
            </div>
            <div class="btnBox">
                <div class="btn1 td-fcc" @click="onPressItem('myCourseVoucher', {id: item.subject_stage.id})">上课凭证</div>
                <div class="btn2 td-fcc" @click="onPressItem('myCourseEnclosure', {id: item.subject_stage.id})">课程专属附件</div>
            </div>
        </div>
    </template>
    <template v-else-if="type === 4">
        <img :src="item.stage_con_cover" alt="">
        <div class="body1">
            <div class="title">
                <p>{{item.stage_con_name}}</p>
            </div>
            <p class="time">{{item.stage_con_start_time + ' ~ ' + item.stage_con_end_time}}</p>
            <div class="address">
                <p>{{item.stage_con_area + item.stage_con_address}}</p>
                <span>{{item.is_pass_text}}</span>
            </div>
            <div class="btnBox">
                <div class="btn1 td-fcc" @click="onPressItem('volunteersVoucher', {id: item.stage_con_id})">服务凭证</div>
                <div class="btn2 td-fcc" @click="onPressItem('myCourseEnclosure', {id: item.stage_con_id})">课程专属附件</div>
            </div>
        </div>
    </template>
</div>
</template>

<script>
export default {
    name: "CourseItem",
    props: [
        'item',
        'type', // 课程报名 2课程介绍 3我的课程 4义工记录
    ],
    methods: {
        _onBack() {
            this.$router.back();
        },

        // 点击跳转
        _onPressToNavigate(pageTitle, path, query) {
            if (pageTitle) {
                query = {
                    ...query,
                    pageTitle,
                }
            }
            this.$router.push({
                path,
                query
            });
        },

        _onPressToWeb(url) {
            if(!url) return;
            window.location.href = url;
        },

        onPressItem(router, query = {}) {
            if(this.type == 4 && this.item.is_pass < 1) {
                return this.ToastManager('您的申请还未通过审核，暂时无法查看');
            }
            this._onPressToNavigate('', router, query);
        },
    }
};
</script>

<style lang="less" scoped>
.item {
    position: relative;
    margin: 10px 15px;
    background: #ffffff;
    border-radius: 10px;
    box-shadow: 0px 0px 5px 0px rgba(51, 51, 51, 0.10);
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .student-num {
        position: absolute;
        top: 10px;
        right: 10px;
        height: 26px;
        padding: 0 15px;
        border-radius: 15px;
        font-size: 12px;
        line-height: 1;
        color: #fff;
        background-color: rgba(0, 0, 0, 0.4);
    }

    >img {
        width: 100%;
        height: 180px;
        object-fit: cover;
    }

    >.body1 {
        padding: 10px;

        .title {
            display: flex;
            align-items: center;

            p {
                flex: 1;
                font-size: 15px;
                color: #333;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                font-weight: 500;
            }

            span {
                font-size: 13px;
                color: #F83535;
                font-weight: 500;

                span {
                    font-size: 18px;
                }
            }
        }

        .line {
            margin-top: 5px;
            display: flex;
            align-items: center;

            p {
                font-size: 15px;
                color: #333333;
                font-weight: 500;
            }

            div {
                height: 20px;
                margin-left: 5px;
                padding: 0 7px;
                border-radius: 10px;
                border: 1px solid #7181EB;
                background: #F1F3FF;
                font-size: 12px;
                color: #7181EB;
                line-height: 20px;
            }
        }

        .time {
            margin-top: 5px;
            font-size: 12px;
            color: #999;
        }

        .address {
            margin-top: 5px;
            display: flex;
            align-items: center;

            p {
                flex: 1;
                font-size: 12px;
                color: #333;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            span {
                padding-left: 10px;
                font-size: 12px;
                color: #333;
            }
        }

        >.btn {
            margin-top: 10px;
            width: 100%;
            height: 35px;
            background: linear-gradient(225deg, #9cb2f4, #6472e8);
            border-radius: 3px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 15px;
            color: #fff;
        }

        >.btnBox {
            margin-top: 10px;
            display: flex;
            justify-content: space-between;

            .btn1 {
                flex: 1;
                margin-right: 20px;
                height: 33px;
                border: 1px solid #7181EB;
                border-radius: 3px;
                line-height: 1;
                text-align: center;
                font-size: 15px;
                color: #7181EB;
            }

            .btn2 {
                flex: 1;
                height: 35px;
                border-radius: 3px;
                background: linear-gradient(205deg, #9cb2f4 1%, #9bb1f4 1%, #6472e8 84%);
                line-height: 1;
                text-align: center;
                font-size: 15px;
                color: #fff;
            }
        }
    }

    >.body2 {
        padding: 10px;

        >div {
            display: flex;
            align-items: center;

            >p {
                flex: 1;
                font-size: 15px;
                color: #333;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            >span {
                font-size: 12px;
                color: #333;
            }
        }

        >p {
            margin-top: 10px;
            font-size: 13px;
            color: #333;
        }

        >.btn {
            margin-top: 10px;
            width: 100%;
            height: 35px;
            background: linear-gradient(225deg, #9cb2f4, #6472e8);
            border-radius: 3px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 15px;
            color: #fff;
        }
    }

    .type {
        position: absolute;
        width: 67px;
        height: 30px;
        background-size: contain;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #7180eb;
        border-radius: 1.5rem 0;

        p {
            font-size: 12px;
            color: #fff;
        }
    }
}
</style>
